const ContactInfo = () => {
    return (
        <div className="w-96">
            <h1 className="text-xl">Contact Information</h1>
            <div><span>Email: </span>ppeerapa1021@gmail.com</div>
            <div><span>Phone: </span>(765)714-8805</div>

            <p className="">
            </p>

        </div>
    );
}
 
export default ContactInfo;